import { Component, OnInit } from '@angular/core';
import { GaleriaService } from '../../../services/galeria.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { VehiculoCliente } from './../../../../../_entities/consola/vehiculo-cliente';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { finalize } from 'rxjs/operators';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
	selector: 'kt-galeria-vehiculos',
	templateUrl: './galeria-vehiculos.component.html',
	styleUrls: ['./galeria-vehiculos.component.scss']
})
export class GaleriaVehiculosComponent implements OnInit {
	public vehiculos: VehiculoCliente[]
	public listaImagenes = [];
	public idCliente: number;
	public loading: boolean = false;
	public loadingVisible: boolean = false;

	constructor(private galeriaService: GaleriaService,
		private toastService: ToastrService,
		private datepipe: DatePipe,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private sanitizer: DomSanitizer
	) { }

	ngOnInit() {
		this.activatedRoute.params.subscribe(
			(params) => {
				this.idCliente = params['idCliente'];
				this.obtenerVehiculos();

			}
		)
	}

	obtenerVehiculos() {
		this.loading = true;
		this.listaImagenes = [];
		this.galeriaService.obtenerVehiculos(this.idCliente).subscribe(
			(vehiculos: VehiculoCliente[]) => {
				if (vehiculos.length) {
					this.vehiculos = vehiculos;
					this.obtenerListaImagenes();

				} else {
					this.toastService.warning('No existen vehiculos')
					this.loading = false;
				}
			}
		)
	}

	 obtenerListaImagenes(){
		const promise = new Promise((resolve, reject) => {
			this.vehiculos.forEach((vehiculo, index, array) => {
				this.galeriaService.obtenerListaImagenes(vehiculo.imei).subscribe(result => {
					if (result.length) {
						this.obtenerImagen(result[0].imei, result[0].foto, result[0].fecha, result[0].economico);
					}
					if (index === array.length -1) {
						resolve(null);
					}
				}, (error) => {
					//console.log(('Error al obtener lista de imagenes'));

				})
			})
		})

		promise.then(() => {
			this.loading = false
		})
	}

	/**Obtener imagen especifica */
	obtenerImagen(imei, foto, fecha, economico) {
		this.galeriaService.obtenerImagenEspecifica(imei, foto).subscribe(result => {
			let url = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(result))
			let properties = {
				url: url,
				fecha: this.datepipe.transform(fecha, 'dd-MM-yyyy h:MM a'),
				economico: economico
			}
			this.listaImagenes.push(properties);
		}, (error) => {
			//console.log('Imagen no disponibles');
		})
	}

	imprimirGaleria(){
		this.loadingVisible = true;
		const galeriaElement = document.getElementById('cards');

		html2canvas(galeriaElement, {useCORS: true}).then(
			(canvas) => {
				let pdf = new jsPDF('p', 'pt', 'a4');
				const mapa = canvas.toDataURL('image/PNG');
				const mapaX = 15;
				const mapaY = 100;
				const mapaProps = (pdf as any).getImageProperties(mapa);
				const mapaWidth = pdf.internal.pageSize.getWidth() - 2 * mapaX;
				const mapaHeight = (mapaProps.height * mapaWidth) / mapaProps.width;

				pdf.addImage(mapa, 'PNG', mapaX, mapaY, mapaWidth, mapaHeight, 'FAST');

				pdf.setFontSize(12);
				pdf.setFont('sans-serif', 'bold')
				pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
				pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
				pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, soporte.star@growtec.com.mx', 65, 825);

				return pdf;

			}
		).then(
			(pdf) => {
				pdf.save('galeria.pdf');
				this.loadingVisible = false;
			}
		)
	}

	regresar() {
		this.router.navigateByUrl('/home/administracion/consola/clientes');
	}


}

